module.exports = __webpack_public_path__ + "static/media/UNI.4c9ffaec.png";